var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import ErrorHandler from '@/support/ErrorHandler';
import { LessonType } from '@/models/LessonType';
import { lessonTypeIcons } from '@/support/Icon';
let AddLessonTypeDialog = class AddLessonTypeDialog extends Vue {
    constructor() {
        super(...arguments);
        this.lessonType = new LessonType();
        this.lessonTypeIcons = null;
        this.selectedLessonTypeIcon = '';
    }
    mounted() {
        this.lessonTypeIcons = lessonTypeIcons;
    }
    close() {
        this.$emit('input', false);
        this.clear();
    }
    create() {
        this.lessonType.icon = this.selectedLessonTypeIcon;
        this.lessonType
            .create()
            .then(() => {
            this.$emit('lessonTypeCreated');
            this.$emit('input', false);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
        this.clear();
    }
    clear() {
        this.lessonType = new LessonType();
    }
};
AddLessonTypeDialog = __decorate([
    Component({
        components: {
        //
        },
    })
], AddLessonTypeDialog);
export default AddLessonTypeDialog;
